import React from 'react';
import { FormattedMessage } from 'react-intl';
import Logo from '~/components/atoms/logo/logo';
import CloseButton from '~/components/molecules/closeButton/CloseButton';
import SearchBar from '~/components/molecules/searchBar/searchBar';
import { UpdateSearchQuery } from '~/core/useSearchState';
import { LogoClickProperties } from '~/hooks/useLogoClickHandler';
import { CloseSERP } from '~/hooks/useShowSearch';
import styles from './header.module.scss';

export interface IHeaderProps {
    updateSearchQuery: UpdateSearchQuery;
    searchQuery: string;
    closeSERP: CloseSERP;
    logoURL: string;
    logoClickProperties: LogoClickProperties;
    headerRef: React.RefObject<HTMLDivElement>;
    autofocus?: boolean;
}

const Header: React.FC<IHeaderProps> = ({
    updateSearchQuery,
    searchQuery,
    closeSERP,
    logoURL,
    logoClickProperties,
    headerRef,
    autofocus,
}) => {
    return (
        <div className={styles.header} ref={headerRef} data-testid="header">
            <Logo alt="logo" logoURL={logoURL} logoClickProperties={logoClickProperties} />
            <SearchBar updateSearchQuery={updateSearchQuery} searchQuery={searchQuery} autofocus={autofocus} />
            <CloseButton closeSERP={closeSERP} data-testid="close-button">
                <FormattedMessage id="close_search" defaultMessage="Zavřít vyhledávání" />
            </CloseButton>
        </div>
    );
};

export default Header;
